<div class="verification">
  <img alt="menu logo" src="{{ LOGO }}" class="img__logo" />
  <div class="title__container">
    <h3 class="main-title">Verifikacija naloga</h3>
  </div>
  <p>Aktiviraj nalog klikom na verifikacioni link koji ti je poslat na e-mail.</p>
  <div class="buttons">
    <button class="btn--orange">
      <a routerLink="/{{ LOGIN_ROUTE }}" class="btn__text">Prijavi se</a>
    </button>
  </div>
</div>
